/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './bootstrap';

window.Vue = require('vue').default;
import CKEditor from 'ckeditor4-vue';
import VueAlertify from "vue-alertify";
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import buttonProcess from "./components/shared/ButtonProcess.vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import "./chunk.js";



/**
 * Next, we will create a fresh Vue application instance. You may then begin
 * registering components with the application instance so they are ready
 * to use in your application's views. An example is included for you.
 */
 Vue.use(CKEditor);
 Vue.component('v-select', vSelect)
 Vue.component('button-process', buttonProcess)
 Vue.component('v-select', vSelect)
 Vue.component('flat-picker', flatPickr)
 Vue.use(VueAlertify)

 const app = new Vue({
    el: '#app',

});
